// kunstli-price-total.js — show absolute size prices, DK currency format
(function () {
  const OVERRIDE = {}; // optional: {"Navneskilt til postkasse": 99}
  let base = null;

  const kr = n => n.toLocaleString("da-DK",
    {minimumFractionDigits: 2, maximumFractionDigits: 2}) + " kr";
  const num = s => parseFloat(String(s).replace(/\./g, "").replace(",", "."));

  function leaves() {
    return [...document.querySelectorAll("body *")].filter(el => !el.children.length);
  }

  function findBase(nodes) {
    for (const k in OVERRIDE) if (document.body.innerText.includes(k)) return OVERRIDE[k];
    // grab the unit price shown while only the base size is selected
    const row = nodes.find(el => /^\s*kr\s*\d[\d.,]*\s*$/i.test(el.textContent)
                              && /stykpris/i.test(el.parentElement?.parentElement?.innerText || ""));
    return row ? num(row.textContent.replace(/kr/i, "")) : null;
  }

  function run() {
    const nodes = leaves();
    if (base === null) base = findBase(nodes);

    nodes.forEach(el => {
      const raw = el.dataset.kOrig ?? el.textContent;

      // size labels: "120 × 48[+kr30]" -> "120 × 48 — 129,00 kr"
      const m = raw.match(/^(.*?)\s*\[\s*\+\s*kr\s*(\d[\d.,]*)\s*\]\s*$/i);
      if (m && base !== null) {
        el.dataset.kOrig = raw;
        el.textContent = `${m[1].trim()} — ${kr(base + num(m[2]))}`;
        return;
      }

      // totals: "kr99.00" -> "99,00 kr"
      const t = raw.match(/^\s*kr\s*(\d[\d.,]*)\s*$/i);
      if (t) {
        el.dataset.kOrig = raw;
        el.textContent = kr(parseFloat(t[1].replace(/,/g, "")));
      }
    });
  }

  let tick;
  new MutationObserver(() => { clearTimeout(tick); tick = setTimeout(run, 60); })
    .observe(document.documentElement, {childList: true, subtree: true});
  run();
})();